import { render, staticRenderFns } from "./PoBalanceCalculation.vue?vue&type=template&id=5487be0e&scoped=true&"
import script from "./PoBalanceCalculation.vue?vue&type=script&lang=js&"
export * from "./PoBalanceCalculation.vue?vue&type=script&lang=js&"
import style0 from "./PoBalanceCalculation.vue?vue&type=style&index=0&id=5487be0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487be0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5487be0e')) {
      api.createRecord('5487be0e', component.options)
    } else {
      api.reload('5487be0e', component.options)
    }
    module.hot.accept("./PoBalanceCalculation.vue?vue&type=template&id=5487be0e&scoped=true&", function () {
      api.rerender('5487be0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/PoBalanceCalculation.vue"
export default component.exports